<template>
  <img :src="flagSrc" alt="Country Flag" class="pix-flag" />
</template>

<script>
import instanceConst from '@/consts/instance.const';
import UK_Flag from '@/assets/flags/united_kingdom.png';
import ES_Flag from '@/assets/flags/spain.png';
import US_Flag from '@/assets/flags/united_states.png';
import CA_Flag from '@/assets/flags/canada.png';
import CH_Flag from '@/assets/flags/china.png';
import FR_Flag from '@/assets/flags/france.png';
import IT_Flag from '@/assets/flags/italy.png';
import PT_Flag from '@/assets/flags/portugal.png';

export default {
  name: 'pix-flag',

  props: {
    country: { type: String, default: null },
  },

  computed: {
    flagSrc() {
      const flagSrcByCountry = {
        [instanceConst.UK]: UK_Flag,
        [instanceConst.ES]: ES_Flag,
        [instanceConst.CA]: CA_Flag,
        [instanceConst.US]: US_Flag,
        [instanceConst.CH]: CH_Flag,
        [instanceConst.FR]: FR_Flag,
        [instanceConst.IT]: IT_Flag,
        [instanceConst.PT]: PT_Flag,
      };

      return flagSrcByCountry[this.country];
    },
  },
};
</script>

<style scoped>
/* The flag's img will adapt to the width of the container */
.pix-flag {
  width: 100%;
}
</style>
